import React from 'react';

export default function SearchFilterBar({ search, onSearchChange, filters = [], onAddClick, addLabel = 'Add New' }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-5">
      <div className="relative flex-1">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30"
          fill="none" viewBox="0 0 24 24" stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search..."
          className="w-full pl-9 pr-3 py-2.5 rounded-xl bg-white/5 ring-1 ring-white/10 text-sm text-white
                     placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-violet-500 transition"
        />
      </div>

      <div className="flex flex-wrap gap-2">
        {filters.map((f) => (
          <select
            key={f.name}
            value={f.value}
            onChange={(e) => f.onChange(e.target.value)}
            className="px-3 py-2.5 rounded-xl bg-white/5 ring-1 ring-white/10 text-sm text-white/70
                       focus:outline-none focus:ring-2 focus:ring-violet-500 transition"
          >
            <option value="" className="bg-[#14141C]">{f.label}</option>
            {f.options.map((opt) => (
              <option key={opt} value={opt} className="bg-[#14141C]">
                {opt}
              </option>
            ))}
          </select>
        ))}

        {onAddClick && (
          <button
            onClick={onAddClick}
            className="px-4 py-2.5 rounded-xl text-sm font-semibold text-white
                       bg-gradient-to-r from-violet-600 to-fuchsia-500 hover:from-violet-500 hover:to-fuchsia-400
                       shadow-lg shadow-violet-900/30 transition whitespace-nowrap"
          >
            + {addLabel}
          </button>
        )}
      </div>
    </div>
  );
}
